import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'

// Member / account backbone for the Pro Shop Suite. Persisted under
// /club/members (the /club node is already writable in the RTDB rules — no
// rules change needed). EVERY future suite record (credit, orders, repairs,
// demos, rentals, lessons, …) references a member by its push-id `memberId`,
// so this is the single source of truth for "who".
//   {memberId}: { id, name, memberNumber, phone, email, notes,
//                 favoriteBrands, active, createdAt }
const BASE = 'club/members'

export function watchMembers(cb) {
  return onValue(tref(BASE), (snap) => cb(snap.val() || {}))
}

// Live single-member subscription for the profile / Member 360 shell.
export function watchMember(id, cb) {
  return onValue(tref(`${BASE}/${id}`), (snap) => cb(snap.val()))
}

export async function createMember({ name, memberNumber, phone, email, notes, favoriteBrands }) {
  const n = String(name || '').trim()
  if (!n) throw new Error('Member name is required.')
  const node = push(tref(BASE))
  await set(node, {
    id: node.key,
    name: n,
    memberNumber: String(memberNumber || '').trim(),
    phone: String(phone || '').trim(),
    email: String(email || '').trim(),
    notes: String(notes || '').trim(),
    favoriteBrands: String(favoriteBrands || '').trim(),
    active: true,
    createdAt: Date.now(),
  })
  return node.key
}

export async function updateMember(id, patch) {
  const clean = {}
  for (const k of ['name', 'memberNumber', 'phone', 'email', 'notes', 'favoriteBrands']) {
    if (patch[k] != null) clean[k] = String(patch[k]).trim()
  }
  if (patch.active != null) clean.active = !!patch.active
  await update(tref(`${BASE}/${id}`), clean)
}

export async function setMemberActive(id, active) {
  await update(tref(`${BASE}/${id}`), { active: !!active })
}

export async function deleteMember(id) {
  await remove(tref(`${BASE}/${id}`))
}
